import React from 'react'

import './style.scss'

const Intro = props => {
  return (
    <div className={'intro ' + (props.noBorder && 'no-border')}>
      {props.children}
    </div>
  )
}

Intro.defaultProps = {
  noBorder: false,
}

export default Intro
